/**
 * Pure sync phase derivation from browser + Firestore signals.
 * UI labels live in syncUtils — not Firestore terminology.
 */

/** @typedef {'live' | 'offline' | 'connecting' | 'saving' | 'waiting_to_sync' | 'error'} SyncPhase */

/**
 * @typedef {Object} SyncInputs
 * @property {boolean} browserOnline
 * @property {boolean} snapshotsInSync
 * @property {boolean} hasPendingWrites
 * @property {boolean} servingFromCache
 * @property {boolean} persistenceReady
 * @property {string | null} [lastError]
 */

/**
 * @param {SyncInputs} inputs
 * @returns {SyncPhase}
 */
export function deriveSyncPhase({
  browserOnline,
  snapshotsInSync,
  hasPendingWrites,
  servingFromCache,
  persistenceReady,
  lastError,
}) {
  if (lastError && !persistenceReady) return "error";

  if (!browserOnline) {
    if (hasPendingWrites) return "waiting_to_sync";
    return "offline";
  }

  if (hasPendingWrites) return "saving";

  if (!snapshotsInSync || servingFromCache) return "connecting";

  return "live";
}

/**
 * @param {SyncPhase} phase
 * @returns {boolean}
 */
export function phaseShowsPendingHint(phase) {
  return phase === "saving" || phase === "waiting_to_sync";
}
